import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ADDRESS } from '../../../core/models/address.model';
import { ValidatorExt } from '../../../core/helpers/validators';
import { TooltipDisplayRegisterContext } from 'src/app/services/tooltip-display.types';

@Component({
  selector: 'app-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.css']
})
export class MailingAddressComponent implements OnInit {

  public formGroup!: UntypedFormGroup;

  @Input() tooltipContext?: TooltipDisplayRegisterContext;
  @Input() title = 'Mailing Address';
  @Input() skipCountry = false;
  @Input() layout = 'vertical';
  @Input() readOnly = false;
  @Input()
  set validate(value: boolean) {
    this._validate = !!value;
    this.applyRequiredValidators();
  }
  get validate(): boolean {
    return this._validate;
  }

  private _validate = false;

  constructor(private fb: UntypedFormBuilder) {
    this.initializeForm();
  }

  ngOnInit() {
    this.applyRequiredValidators();
  }

  public get formValue(): {
    address1: string,
    suburb: string,
    state: string,
    postCode: string,
    country: string,
    type: string,
    id: number
  } {
    return {
      address1: this.formGroup.value.address1,
      suburb: this.formGroup.value.suburb,
      state: this.formGroup.value.state,
      postCode: this.formGroup.value.postCode,
      country: this.formGroup.value.country,
      type: this.formGroup.value.type,
      id: this.formGroup.value.id
    }
  }

  public patchValue(formValue: {
    id?: number;
    address1: string,
    suburb: string,
    state: string,
    postCode?: string,
    country: string,
    type?: string
  }): void {
    if (formValue) {
      this.formGroup.patchValue(formValue);
    }
  }

  private initializeForm(): void {
    this.formGroup = this.fb.group({
      id: 0,
      address1: [''],
      suburb: [''],
      state: [''],
      postCode: [''],
      country: [''],
      type: ['']
    })
  }

  public resetForm() {
    this.formGroup.reset();
  }

  public setAddress(address: ADDRESS) {
    this.resetForm();
    if (address == null) return;

    this.formGroup.patchValue(address);
    if (this.readOnly) {
      this.formGroup.get('address1')?.disable();
      this.formGroup.get('suburb')?.disable();
      this.formGroup.get('state')?.disable();
      this.formGroup.get('postCode')?.disable();
      this.formGroup.get('country')?.disable();
      this.formGroup.get('type')?.disable();
    }
  }

  private applyRequiredValidators() {
    const address1Control = this.formGroup.get('address1');
    const suburbControl = this.formGroup.get('suburb');
    const stateControl = this.formGroup.get('state');
    const postCodeControl = this.formGroup.get('postCode');

    if (this._validate) {
      address1Control?.setValidators([Validators.required]);
      suburbControl?.setValidators([Validators.required]);
      stateControl?.setValidators([Validators.required]);
      postCodeControl?.setValidators([Validators.required, ValidatorExt.postcode()!]);
    } else {
      address1Control?.clearValidators();
      suburbControl?.clearValidators();
      stateControl?.clearValidators();
      postCodeControl?.setValidators([ValidatorExt.postcode()!]);
    }

    address1Control?.updateValueAndValidity({ emitEvent: false });
    suburbControl?.updateValueAndValidity({ emitEvent: false });
    stateControl?.updateValueAndValidity({ emitEvent: false });
    postCodeControl?.updateValueAndValidity({ emitEvent: false });
  }

}
